// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-4eac759b]{margin:32px 0;width:100%;height:180px;border-radius:16px;background-size:cover;background-position:50%}", ""]);
// Exports
module.exports = exports;
